export const article = {
  sections: {
    posties: "515415",
  },
  types: {
    analysis: {
      entityId: "328387",
    },
    column: {
      entityId: "783",
    },
    debate: {
      entityId: "328051",
    },
    editorial: {
      entityId: "500285",
    },
    explainer: {
      entityId: "328386",
    },
    factCheck: {
      entityId: "328388",
    },
    infographic: {
      entityId: "27557",
    },
    letters: {
      entityId: "329083",
    },
    live: {
      entityId: "27556",
      entityUuid: "c95a7a01-e8fe-4d06-b8fd-248824cb9c5f",
    },
    longRead: {
      entityId: "328194",
    },
    newsletter: {
      entityId: "507042",
    },
    obituary: {
      entityId: "328389",
    },
    opinion: {
      entityId: "328587",
    },
    photoEssay: {
      entityId: "328710",
    },
    podcast: {
      entityId: "328588",
    },
    profile: {
      entityId: "509368",
    },
    qa: {
      entityId: "16560",
    },
    review: {
      entityId: "318341",
    },
    series: {
      entityId: "506855",
    },
    seriesDefaultLabel: {
      entityId: "509605",
    },
    studio: {
      entityId: "328367",
    },
    studioMorningStudioLogoOnly: {
      entityId: "503583",
    },
    studioScmpLogoOnly: {
      entityId: "503582",
    },
  },
} as const;

export const acknowledgementGateArticleIds = new Set([
  "1780152",
  "1781385",
  "1783122",
  "1782752",
  "1785202",
  "1786367",
  "1787941",
  "1788985",
  "1854626",
  "1855229",
  "1857242",
  "1862338",
  "1863178",
  "1863522",
  "1784494",
  "1815689",
  "1840168",
  "1840737",
  "1944555",
  "2057808",
]);
